import { JSXElementConstructor, ReactElement } from 'react';
import { MAX_TOAST_DURATION, TOAST_DURATION_PER_CHAR } from '../constants';

export const getToastDuration = (
  message: string | ReactElement<any, string | JSXElementConstructor<any>>
) => {
  const chars = typeof message === 'string' ? message.length : 1000;

  return Math.max(chars * TOAST_DURATION_PER_CHAR, MAX_TOAST_DURATION);
};
